// extracted by mini-css-extract-plugin
export default {"container":"Cropper_container__LLvKk"};